export class Email {
  destinatario: string;
  numeroCupom: string;
  nomeDentista: string;
  descontos: string[];
}
